module.exports = __webpack_public_path__ + "media/images/flags/32/Guernsey-62ca70d774f9a56493e555a06282419b.png";